import { paymentMethodCreationSuccess } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

export default function createPaymentMethodSuccess() {
  return addMessage(paymentMethodCreationSuccess);
}
